'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var enums = require('../../types/cms/enums.js');
var classes = require('../../types/cms/classes.js');

/**
 * This is a dictionary used to keep track of all registered class targets.
 * It enables retrieving metadata with a key.
 */
const _metadataDataTargetByKey = {};
/**
 * Utility to retrieve metadata from a given class.
 */
const getClassMetadata = (ClassRef) => {
    const instance = new ClassRef();
    if (!instance.isCMSFields) {
        throw new Error(`Class is not for a CMS component`);
    }
    const metadataKeys = Reflect.getMetadataKeys(instance);
    const objectMetadata = Reflect.getMetadata(enums.MetadataTypes.Object, instance);
    const fields = metadataKeys
        .filter(k => k !== enums.MetadataTypes.Object)
        .map(key => Reflect.getMetadata(key, instance));
    return new classes.ClassMetadata(objectMetadata === null || objectMetadata === void 0 ? void 0 : objectMetadata.key, objectMetadata === null || objectMetadata === void 0 ? void 0 : objectMetadata.name, fields, objectMetadata === null || objectMetadata === void 0 ? void 0 : objectMetadata.options);
};
/**
 * Utility to retrieve metadata from a list of classes.
 */
const getClassesMetadata = (classRefs) => {
    const classNames = Object.keys(classRefs).filter(key => key !== '__esModule');
    return classNames.map((cn) => {
        return getClassMetadata(classRefs[cn]);
    });
};
/**
 * Utility use to register class Metadata to support retrieval of metadata
 * by key
 */
const setClassMetadataByKey = (key, ClassRef) => {
    _metadataDataTargetByKey[key] = ClassRef;
};
/**
 * Utility use to retrieve class metadata by key
 */
const getClassMetadataByKey = (key) => {
    const ClassRef = _metadataDataTargetByKey[key];
    if (!ClassRef) {
        return null;
    }
    return getClassMetadata(ClassRef);
};

exports.getClassMetadata = getClassMetadata;
exports.getClassMetadataByKey = getClassMetadataByKey;
exports.getClassesMetadata = getClassesMetadata;
exports.setClassMetadataByKey = setClassMetadataByKey;
//# sourceMappingURL=cmsMetadataUtilities.js.map
